import { useEffect } from "react"

import { FormTabsStoreProvider, useFormTabsStore } from "./form_tabs.context"
import type { IFormTabs } from "./form_tabs.interface"
import FormLineTextLine from "./partials/form_tab_text_line"

const GroupInner: IFormTabs["Group"] = ({ children }) => {
  const selectedTab = useFormTabsStore((s) => s.currentTabIndex)
  const initaliseTabs = useFormTabsStore((s) => s.initaliseTabs)
  const tabStatuses = useFormTabsStore((s) => s.tabStatuses)

  useEffect(() => {
    initaliseTabs(children.length)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <div
        style={{
          gridTemplateColumns: `repeat(${children.length}, minmax(0, 1fr))`,
        }}
        className="grid w-full items-start justify-start gap-4"
      >
        {children.map((child, index) => (
          <FormLineTextLine
            key={index}
            title={child.props.label}
            description={child.props.description}
            tabKey={index}
            activeTab={selectedTab}
            status={tabStatuses[index]}
          />
        ))}
      </div>
      <div className="py-8">
        {children.map((child, index) => (
          <div key={index} hidden={index !== selectedTab}>
            {child}
          </div>
        ))}
      </div>
    </div>
  )
}

const FormTabs: IFormTabs = {
  Group: (props) => (
    <FormTabsStoreProvider onSubmit={props.onSubmit}>
      <GroupInner {...props} />
    </FormTabsStoreProvider>
  ),
  Item: ({ children }) => children,
}

export default FormTabs
